import { Container } from "react-bootstrap";
import cn from "classnames";

export const Spacer = ({ className }) => {
    return (
        <section className={cn(className)}>
            <Container className="mw-xxl" />
        </section>
    );
};

export default Spacer;
